import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { NavItem, NavLink } from 'shards-react';

const SignInMenu = ({ signIn, history, openModal }) => {
  return (
    <Fragment>
      <NavItem>
        <NavLink className='text-white' href='/login'>
          Login
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className='text-white' href='/register'>
          Register
        </NavLink>
      </NavItem>
    </Fragment>
  );
};

export default withRouter(SignInMenu);
